import axios from 'axios';
import type { HostedReport } from '../types/report.types';

/**
 * The hosted report's only call.
 *
 * Relative path, proxied to the backend in development and same-origin in
 * production. No auth header and no cookie is expected: the share token in the
 * URL is the whole authorization, because the client reading this report has no
 * account.
 */
export const fetchHostedReport = async (
  shareToken: string,
): Promise<HostedReport> => {
  const { data } = await axios.get<{ success: boolean; data: HostedReport }>(
    `/api/public/reports/${encodeURIComponent(shareToken)}`,
  );
  return data.data;
};

/**
 * The street map behind one scan grid, served through the backend so it
 * loads on any agency's hostname. `index` is the keyword's position in
 * `mapPack.scanGrid`. A relative path, for the same reason as the report call.
 */
export const scanMapUrl = (
  token: string,
  preview: boolean,
  index: number,
  side: 'now' | 'baseline',
): string =>
  `/api/public/reports/${preview ? 'preview/' : ''}${encodeURIComponent(
    token,
  )}/map/${index}/${side}`;

/**
 * A preview the agency just built in the app, by its short-lived token. Same
 * shape as a sent report, flagged `isPreview`.
 */
export const fetchReportPreview = async (
  previewToken: string,
): Promise<HostedReport> => {
  const { data } = await axios.get<{ success: boolean; data: HostedReport }>(
    `/api/public/reports/preview/${encodeURIComponent(previewToken)}`,
  );
  return data.data;
};
